<template>
    <div>

        <h1 class="mt-4">Alla erbjudanden<button class="btn btn-primary btn-sm ms-6" @click="createDeal()">
            Lägg till erbjudande
        </button></h1>

        <div class="content-container">

            <div class="row g-3 mb-4">
                <div class="col-24 col-md-5 mb-4 mb-md-0">
                    <input type="text"
                           class="form-control new-list-group-field"
                           placeholder="Sök titel, företag"
                           v-model="settings.query.text"
                    >
                </div>
            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col-1">
                            <span>{{ props.item.id }}</span>
                        </div>
                        <div class="col-2 align-items-start" style="font-size: 18px;">
                            <span class="fa fa-arrow-down" @click="reOrder(props.item.id, items[itemIndex(props.item.id) + 1].order)" v-if="!settings.query.text && items[itemIndex(props.item.id) + 1]"></span>
                            <span class="fa fa-arrow-up" @click="reOrder(props.item.id, items[itemIndex(props.item.id) - 1].order)" v-if="!settings.query.text && items[itemIndex(props.item.id) - 1]"></span>
                        </div>
                        <div class="col-5">
                            <span>{{ props.item.title }}</span>
                        </div>
                        <div class="col-4">
                            <span>{{ props.item.company_name }}</span>
                        </div>
                        <div class="col-3">
                            <span>{{ props.item.valid_from }}</span>
                        </div>
                        <div class="col-3">
                            <span>{{ props.item.valid_to }}</span>
                        </div>
                        <div class="col-3">
                            <span class="fa fa-check" v-if="props.item.is_public"></span>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <a :href="'/deals/'+props.item.id">
                                <button class="btn btn-primary btn-sm me-1">Hantera
                                    <div class="tooltip-label">Redigera och hantera dealen</div>
                                </button>
                            </a>
                            <button class="btn btn-danger btn-sm" @click="triggerDelete(props.item.id)">
                                <img src="/images/admin/icon-trash.svg">
                                <div class="tooltip-label">Radera</div>
                            </button>
                        </div>
                    </div>
                </div>
            </list>

        </div>

    </div>
</template>

<script>

import lister from '../../shared/mixins/lister'
import deleter from '../../shared/mixins/deleter'

import axios from 'axios'
export default {

    mixins: [
        lister,
        deleter
    ],

    data () {
        return {
            settings: {
                url: '/deals/list',
                query: {
                    text: ''
                },
                columns: [
                    { column: 'id', name: 'ID', class: 'col-1', sortable: false },
                    { column: 'order', name: 'Ordning', class: 'col-2', sortable: false, default: true },
                    { column: 'title', name: 'Titel', class: 'col-5', sortable: false },
                    { column: 'company_name', name: 'Företag', class: 'col-4', sortable: false },
                    { column: 'valid_from', name: 'Giltigt från', class: 'col-3', sortable: false },
                    { column: 'valid_to', name: 'Giltigt till', class: 'col-3', sortable: false },
                    { column: 'is_public', name: 'Publicerad', class: 'col-3', sortable: false }
                ],
                bulk_actions: []
            }
        }
    },

    mounted () {
        this.$refs.list.pagination.limit = 5000
    },

    computed: {
        deleterUrl () {
            return '/deals'
        },
        items () {
            return this.$refs.list.items
        }
    },

    methods: {
        createDeal () {
            axios.post('/deals')
                .then(response => {
                    window.location.href = '/deals/' + response.data.deal_id
                })
        },

        triggerDelete (deal_id) {
            if (!confirm('Vill du verkligen radera erbjudandet?')) {
                return
            }
            this.deleterDelete(deal_id)
        },

        deleterSuccess () {
            bus.$emit(
                'notify',
                'Dealen har raderats'
            )
            this.refresh()
        },

        itemIndex (item_id) {
            return this.items.findIndex(i => i.id === item_id)
        },

        reOrder (item_id, new_order) {
            axios.post('/deals/' + item_id + '/reOrder', { order: new_order })
                .then(response => {
                    this.refresh()
                })
        }
    }
}
</script>
